
<template>
    <div class="login-security">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path
          d="M8 10V7C8 4.8 9.8 3 12 3C14.2 3 16 4.8 16 7V10"
        />
        <path d="M12 14V17" />
      </svg>
  
      <span>{{ message }}</span>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginSecurity',
  
    props: {
      message: {
        type: String,
        default: 'Koneksi aman dan data terlindungi.'
      }
    }
  }
  </script>
  
  <style scoped>
  .login-security {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 25px;
    color: #8b96a9;
    font-size: 11px;
    line-height: 1.6;
    text-align: center;
  }
  
  .login-security svg {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
    stroke: #20a69a;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  </style>
  